import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { useFormContext } from "react-hook-form";

import Dropdown from "components/atoms/Dropdown/Dropdown";
import InputField from "components/atoms/InputField/InputField";
import { cbmScopeOptions } from "../PackingListDefaultOptions";

function CBMFields() {
  const intl = useIntl();
  const { watch } = useFormContext();
  const cbmScope = watch("cbm_scope");
  // Dynamic field_id based on cbmScopeValue
  const cbmFieldId = `l_w_h_cbm_${cbmScope}`;

  return (
    <>
      {cbmScope && (
        <div className="flex-row packing-list-add-item-input-large">
          <InputField
            label={intl.formatMessage({
              id: "new-request.packing-list.cubicMeters",
              defaultMessage: "Cubic Meters (CBM)",
            })}
            placeholder={intl.formatMessage({
              id: "new-request.packing-list.pleaseProvide",
              defaultMessage: "Please provide",
            })}
            field_id={cbmFieldId}
            validations={{
              validate: {
                onlyNumber: (v: any) => !isNaN(v) || "Please enter a valid number",
              },
              setValueAs: (v: string) => (!v ? null : v),
              shouldUnregister: true,
            }}
            required
          />
        </div>
      )}
      <div className="ml-2 packing-list-add-item-input-large">
        <label className="no-wrap">
          <FormattedMessage id="new-request.packing-list.cubicScope" defaultMessage="CBM Scope" />
        </label>
        <Dropdown
          useHookForm
          name="cbm_scope"
          required
          className="schedule-dropdown"
          options={cbmScopeOptions(intl)}
          defaultValue={cbmScopeOptions(intl)[0].value}
        />
      </div>
    </>
  );
}

export default CBMFields;
